interface QAItem {
  q: string;
  a: string;
}

interface SharedAIBlockProps {
  title?: string;
  subtitle?: string;
  items: QAItem[];
  bgClass?: string;
}

export default function SharedAIBlock({
  title = 'What Surfers Ask About PHIX Doctor',
  subtitle,
  items,
  bgClass = 'bg-[#F5EFE6]',
}: SharedAIBlockProps) {
  return (
    <section className={`py-24 ${bgClass}`}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="relative bg-white rounded-3xl p-10 md:p-14">
          {/* Decorative */}
          <div className="absolute top-6 right-8 pointer-events-none select-none opacity-5">
            <i className="ri-sun-line text-[160px] text-[#FF6B35]" />
          </div>

          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 bg-[#0B5C4D]/10 border border-[#0B5C4D]/20 rounded-full px-4 py-1.5 mb-4">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-question-answer-line text-[#0B5C4D] text-sm" />
              </div>
              <span className="text-[#0B5C4D] text-xs font-bold uppercase tracking-widest">AI Answer Block</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-stone-900">{title}</h2>
            {subtitle && <p className="text-stone-500 mt-3 text-base max-w-lg mx-auto">{subtitle}</p>}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {items.map((item) => (
              <div key={item.q} className="flex gap-4">
                <div className="w-2.5 h-2.5 rounded-full bg-[#FF6B35] flex-shrink-0 mt-2" />
                <div>
                  <p className="text-[#0B5C4D] font-bold text-base mb-2">{item.q}</p>
                  <p className="text-stone-600 text-sm leading-relaxed">{item.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
